import { render, staticRenderFns } from "./AddCategoryModal.vue?vue&type=template&id=3cc8f5b5&scoped=true"
import script from "./AddCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./AddCategoryModal.vue?vue&type=style&index=0&id=3cc8f5b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc8f5b5",
  null
  
)

export default component.exports